import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { Master, MasterService } from '../../entities/master';
import { User, UserService } from '../../shared';
import { CustomDatePipe } from '../../shared/utils/date.pipe';
import { UtilsService } from '../../shared/utils/utils.service';

@Component({
    selector: 'jhi-user-mgmt-detail',
    templateUrl: './user-management-detail.component.html'
})
export class UserMgmtDetailComponent implements OnInit, OnDestroy {

    user: User;
    private subscription: any;
    masters: Master[];

    constructor(
        private userService: UserService,
        private route: ActivatedRoute,
        public utilsService: UtilsService,
        private masterService: MasterService,
        private datePipe: CustomDatePipe
    ) {
    }

    async ngOnInit() {
        this.masters = await this.masterService.getMasters().toPromise();
        this.subscription = this.route.params.subscribe(params => {
            this.load(params['email']);
        });
    }

    load (email) {
        this.userService.find(email).subscribe(user => {
            user.createdDate = this.datePipe.transform(user.createdDate);
            user.lastModifiedDate = this.datePipe.transform(user.lastModifiedDate);
            this.user = user;
        });
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    masterFromInm(inm: string): Master {
        return this.masters.find(m => m.masterInm === inm);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/admin/user-management/user-management-detail.component.ts